var render = function render(_c,_vm){return _c('div',[_c('el-tag',{attrs:{"type":`${
      !_vm.props.row.hour_type
        ? 'danger'
        : _vm.props.row.hour_type.includes('Nocturna')
        ? 'secondary'
        : 'info'
    }`}},[_vm._v("\n    "+_vm._s(_vm.props.row.hour_type
        ? _vm.props.row.hour_type
        : _vm.$t('common_words.no_assignment'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }